import { action } from '../actions';

export const FETCH_SERVICE_COMPLAINTS = 'FETCH_SERVICE_COMPLAINTS';
export const REQUEST_SERVICE_COMPLAINTS = 'REQUEST_SERVICE_COMPLAINTS';
export const SUCCESS_SERVICE_COMPLAINTS = 'SUCCESS_SERVICE_COMPLAINTS';
export const FAILURE_SERVICE_COMPLAINTS = 'FAILURE_SERVICE_COMPLAINTS';

export const fetchServiceComplaints = () => action(FETCH_SERVICE_COMPLAINTS);
export const requestServiceComplaints = () => action(REQUEST_SERVICE_COMPLAINTS);
export const requestServiceComplaintsSuccess = (response: any) => action(SUCCESS_SERVICE_COMPLAINTS, { response });
export const requestServiceComplaintsFailure = (error: any) => action(FAILURE_SERVICE_COMPLAINTS, { error });
